module.exports = __webpack_public_path__ + "82d51efa880a6db877482b723f450ae6.pdf";